import { UrlForm } from '@/components/UrlForm';
import { useT } from '@/lib/useLang';

/** Le rappel d'offre en bas des pages de blog — même formulaire que la landing. */
export function BlogCta() {
  const t = useT();

  return (
    <section className="nz-cta">
      <div className="nz-cta__inner">
        <div>
          <h2 className="nz-h2">{t.blogCtaH2}</h2>
          <p className="nz-cta__p">{t.blogCtaP}</p>
        </div>
        <div className="nz-cta__form">
          <UrlForm id="blog-linkedin-url" variant="compact" />
          <div className="nz-cta__note">{t.ctaNote}</div>
        </div>
      </div>
    </section>
  );
}
